/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ActivityLogRoutes from './activity-log.routes';
import ActivityLogController from './activity-log.controller';
import ActivityLogStateController from './activity-log-state.controller';

export default angular.module('tektelic.activityLog', [])
    .config(ActivityLogRoutes)
    .controller('ActivityLogController', ActivityLogController)
    .controller('ActivityLogStateController', ActivityLogStateController)
    .name;



// WEBPACK FOOTER //
// ./src/app/activity-log/index.js